// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__j4Bt6","main":"style_main__zs4f3","bg":"style_bg__7yP9a","icon":"style_icon__ulRaX","btn":"style_btn__+L8sr"};